<template>
  <v-layout elevation-7>
    <v-flex>
      <v-card v-if="model != null"
      >
        <v-parallax
          src="/static/images/epost-card.jpg"
          height="150"
        >
          <v-layout
            align-center
            column
            justify-center
            class="lightbox2"
          >
            <h1 class="display-1 mb-1 s-card-title font-effect-3d-float">우체국</h1>
            <h4
              style="width:100%; padding-left:10px; padding-right:10px;"
              class="subheading s-card-subtitle text-xs-center">{{ model.baseInfo.lastStep }}</h4>
          </v-layout>
        </v-parallax>

        <v-container
          id="grid"
          fluid
          grid-list-sm
          tag="section"
        >
          <v-layout wrap>
            <v-flex xs6 pl-2 pr-2>
              <label-text title="보내는분" :text="(model.baseInfo.sender === '') ? '알수없음': model.baseInfo.sender"></label-text>
              <v-divider></v-divider>
            </v-flex>
            <v-flex xs6 pl-2 pr-2>
              <label-text title="발송일" :text="(model.baseInfo.sendDate === '') ? '알수없음': model.baseInfo.sendDate"></label-text>
              <v-divider></v-divider>
            </v-flex>
            <v-flex xs6 pl-2 pr-2>
              <label-text title="받는분" :text="(model.baseInfo.receiver === '') ? '알수없음': model.baseInfo.receiver"></label-text>
              <v-divider></v-divider>
            </v-flex>
            <v-flex xs6 pl-2 pr-2>
              <label-text title="수령일" :text="(model.baseInfo.receiveDate === '') ? '알수없음': model.baseInfo.receiveDate"></label-text>
              <v-divider></v-divider>
            </v-flex>
            <!--<v-flex xs4>-->
            <!--<v-flex class="subheading">취급구분</v-flex>-->
            <!--<v-card flat dark>-->
            <!--<v-card-text class="info-table">{{ model.baseInfo.deliverType || '&nbsp'}}</v-card-text>-->
            <!--</v-card>-->
            <!--</v-flex>-->
          </v-layout>
        </v-container>
        <v-divider></v-divider>

        <v-container v-if="!hasResult" fill-height fluid>
          <v-layout column class="text-xs-center">
            <v-flex>
              <h1 v-if="!hasResult" class="title">조회된 데이터가 없습니다</h1>
            </v-flex>
          </v-layout>
        </v-container>

        <v-flex>
          <template v-for="(item, index) in listReverse">
            <delivery-list-item v-bind:key="index"
              v-bind:title="(item.status === '' || item.status === '&nbsp;') ? '-' : item.status"
              v-bind:green-chip="item.store"
              v-bind:primary-chip="item.step"
              v-bind:date="item.date + ' ' + item.time"></delivery-list-item>
            <v-divider v-if="index + 1 < model.list.length" :key="`divider-${index}`"></v-divider>
          </template>
        </v-flex>

      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import LabelText from '../LabelText'
import DeliveryListItem from '../DeliveryListItem'

export default {
  // data: () => ({
  //   lorem: `Lorem ipsum dolor sit amet, mel at clita quando. Te sit oratio vituperatoribus, nam ad ipsum posidonium mediocritatem, explicari dissentiunt cu mea. Repudiare disputationi vim in, mollis iriure nec cu, alienum argumentum ius ad. Pri eu justo aeque torquatos.`
  // }),
  name: 'EPostDeliveryCard',
  props: ['model'],
  components: {LabelText, DeliveryListItem},
  computed: {
    hasResult: function () {
      return this.model.list.length > 0
    },
    listReverse: function () {
      return [...this.model.list].reverse()
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/card/EPostDeliveryCard.vue